;(function($) {

// ---------- APP START
window.App = {

  config: {
    scrollOffset: 150
  },

  init: function() {
   // App.initForms();*/
   if($('.anim-equal').length) {
			App.initMenu();
			App.initAudios();
			App.initAnims();
		}
		
		if($('#fullpage')) App.prepareSections();
  },

  load: function() {
  },
	
	initMenu: function() {
		$('.js-nav-toggler').on('click', function(e) {	
			$('body').addClass('is-nav-open');
		});
		$('.menu-close').on('click', function(e) {			
			$('body').removeClass('is-nav-open');
		});
		$('.nav-menu a').on('click', function(e) {			
			$('body').removeClass('is-nav-open');
		});
	},	
	
	initAnims: function() {
		var $anim2 = document.getElementById('anim-equal');
		var animData2 = {
			container: $anim2,
			renderer: "svg",
			loop: true,
			autoplay: true,
			path: "/assets/json/equalizer.json"
		};
		var animData3 = {
			container: document.getElementById('anim-mouse'),
			renderer: "svg",
			loop: true,
			autoplay: true,
			path: "/assets/json/mouse.json"
		};
				
		var anim2 = lottie.loadAnimation(animData2);
				anim2.onEnterFrame = function(){ anim2.setSpeed(0.5);};
		var anim3 = lottie.loadAnimation(animData3);
		
		$(window).scroll(function() {
			var scroll = $(window).scrollTop();
			if (scroll >= 150) anim2.stop();
			else anim2.play();
		});
		
		var $activity_menu = $('.activity__items li');
		
		$activity_menu.mouseover(function() {
			$activity_menu.removeClass('active');
			$(this).addClass('active');
		});
		
		var $about_menu = $('.aboutus li');
		
		$about_menu.mouseover(function() {
			$about_menu.removeClass('active');
			$(this).addClass('active');
		});		
	},
	
	prepareSections: function() {		
		var myFullpage = new fullpage('#fullpage', {
				licenseKey: 'OPEN-SOURCE-GPLV3-LICENSE',
        anchors: ['accueil','nos-activites', 'nos-realisations','un-peu-de-son','nos-references','qui-sommes-nous'],
				//lockAnchors: false,
				responsiveWidth: 1024,
        scrollBar: false,
				fitToSection: true,
				onLeave: function(origin){
					if(origin.index == 3){
						$('body').removeClass('is-audio-open');
					}
				}
    });
		
		$('.anim-mouse').on('click', function(e) {
			e.preventDefault();
			myFullpage.moveSectionDown();
		});
	},
	
	initAudios: function() {
		var litebox = $('.lightbox-au-content');
		$('.js-lightbox-au').on('click', function(e) {
			e.preventDefault();
			var content = $(this).parent().find('span').text();
					//console.log(JSON.parse(content));
					litebox.html(content);
			$('body').addClass('is-audio-open');
		});
		$('.js-lightbox-au-close').on('click', function(e) {
			e.preventDefault();
			litebox.html(null);
			$('body').removeClass('is-audio-open');
		});		
	},
	
  initForms: function() {
    $('.sv-form [name=token]').val($('meta[name=refresh]').attr('content'));
  },
};
// ---------- APP END

// Init app
$(document).ready(App.init);
})(Zepto);